

module.exports = __webpack_require__.stylable.create(
    "SubscriptionPlan3334126397",
    {"classes":{"root":"SubscriptionPlan3334126397__root","subscriptionPlanRadioButton":"SubscriptionPlan3334126397__subscriptionPlanRadioButton"},"vars":{},"stVars":{"subscriptionPlanBorderBoxColor":"'\"fallback(color(--productPage_subscriptionPlansBoxColor), black)\"'"},"keyframes":{}},
    "",
    14,
    "SubscriptionPlan3334126397",
    null
);
